import { FunctionComponent } from 'react'
import type { LayoutFooterProps } from './types'
import TimeZone from '@/components/TimeZoneLuxon'
import { useStyles } from './styles'
import { RenderIf } from '@/components/RenderIf'

export const LayoutFooter: FunctionComponent<LayoutFooterProps> = ({
  children,
  hideDate,
  copyContent,
  styles,
}) => {
  const defaultStyles = useStyles()

  return (
    <div style={styles?.root}>
      <div css={defaultStyles.body} style={styles?.body}>
        <RenderIf condition={Boolean(children)}>
          <span>{children}</span>
        </RenderIf>

        <RenderIf condition={!hideDate}>
          <div css={defaultStyles.gmtWrapper}>
            <TimeZone />

            <RenderIf condition={Boolean(copyContent)}>
              <div css={defaultStyles.copyText}>{copyContent}</div>
            </RenderIf>
          </div>
        </RenderIf>
      </div>
    </div>
  )
}
